<template>
  <div>
      <div class="box" v-if="loggedIn">
          <navbar />
      </div>
    <div>
        <router-view :api="api" :user="user" />
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/navbar/store.vue'
export default {
    components: {
        Navbar
    },
    name:'Store',
    beforeCreate(){
        this.$store.dispatch('setPage', {
            location:{name:'store', number:10},
            title:'mercado del jugador',
            breadcrumb:[
                {name:'inicio',link:this.$store.state.baseUrl,active:true,icon:'home'},
                {name:'Mercado',link:'/mercado',active:false,icon:'shopping-cart'}
            ]
        })
    },
    computed: {
        loggedIn() {
            return this.$store.state.auth.status.loggedIn;
        },
        user() {
            return this.$store.state.auth.user;
        },
        api() {
            return this.$store.getters.GetApiPath
        },
    }
}
</script>

<style>

</style>